import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { GlobalService } from 'src/app/services/global.service';

@Component({
    selector: 'app-choose-user',
    standalone: false,
    templateUrl: './choose-user.component.html',
    styleUrls: ['./choose-user.component.scss'],
})
export class ChooseUserComponent implements OnInit {
    constructor(public glo: GlobalService, public dialogRef: MatDialogRef<ChooseUserComponent>) {}

    ngOnInit() {}

    selectMitarbeiter(ma: any) {
        this.dialogRef.close(ma);
    }
}
